/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { fetchWithTimeout } from '../../../../core/fetch/fetch';
import FileSystemFile from '../system/file-system-file';

/**
 * @import { FileTransferManager as IFileTransferManager } from '../../../../core/file/transfer'
 * @import FileSystemManager from '../system/file-system-manager'
 */

/**
 * Správce přenosů souborů po síti pro webovou platformu.
 * @implements {FileTransferManager}
 */
class FileTransferManager {
  /** @type {IFileTransferManager['download']} */
  /**
   * @param {FileSystemManager} fileSystemManager
   */
  constructor(fileSystemManager) {
    this.fileSystemManager = fileSystemManager;
  }

  /** @type {IFileTransferManager['download']} */
  async download(path, input, init) {
    const response = await fetchWithTimeout(input, init);
    if (response.body === null) {
      throw new Error('Response body is null.');
    }
    const fileHandle = await this.fileSystemManager.writeStream(
      path,
      response.body
    );

    return {
      file: new FileSystemFile(path, fileHandle, this.fileSystemManager),
      response
    };
  }
}

export default FileTransferManager;
